export const unreachable = (): never => {
  throw Error('unreachable method called');
};
